import React from "react";
import { TransactionHistoryContainer } from "../../../containers";

const History = (props) => {
  return <TransactionHistoryContainer {...props} />;
};

export default History;
